import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import { Col, Row, Spinner } from "react-bootstrap";
import { Tabs } from "antd";
import TabPane from "antd/lib/tabs/TabPane";
import Events from "./event";
import AnnouncementsList from "./announcementList";
import { _GET_PAGE } from "../../models/fieldSettings";

const HomeMenus = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [activeKey, setActiveKey] = useState("1");
  const [dataList, setDataList] = useState([]);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  useEffect(() => {
    loadPage();
  }, [activeKey]);

  const loadPage = () => {
    setLoader(true);
    _GET_PAGE(field(activeKey == "2" ? "pageIdOne" : "pageIdTwo")).then(
      (res) => {
        if (res.status == "1") {
          setDataList(res.data);
        }
        setLoader(false);
      }
    );
  };

  const pageField = (fieldName) => dataList[fieldName] || "";

  return (
    <div>
      <section
        className="py-2"
        style={{ backgroundColor: field("bgColor") || "#fff" }}
      >
        <Row>
          <Col md={12}>
            <Tabs
              centered
              activeKey={activeKey}
              type="line"
              onChange={setActiveKey}
            >
              <TabPane tab="Events" key="1" />
              <TabPane tab={field("pageTitleOne") || "Title One"} key="2" />
              <TabPane tab={field("pageTitleTwo") || "Title Two"} key="3" />
              <TabPane tab="Announcements" key="4" />
            </Tabs>
          </Col>
        </Row>
        <Row>
          {loader && (
            <center>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </center>
          )}
          <Col md={12}>
            {activeKey == "1" && <Events />}
            {activeKey == "2" && (
              <div style={{ maxHeight: "500px" }}>
                <section className="py-4">
                  <div className="container card pad-bot-70 pg-inn ps_min_height ">
                    <h4 className="text-center">
                      {field("pageTitleOne") || "Title One"}
                    </h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageField("content_html"),
                      }}
                    />
                  </div>
                </section>
              </div>
            )}
            {activeKey == "3" && (
              <div style={{ maxHeight: "500px" }}>
                <section className="py-4">
                  <div className="container card pad-bot-70 pg-inn ps_min_height ">
                    <h4 className="text-center">
                      {field("pageTitleTwo") || "Title Two"}
                    </h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: pageField("content_html"),
                      }}
                    />
                  </div>
                </section>
              </div>
            )}
            {activeKey == "4" && <AnnouncementsList />}
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default HomeMenus;
